// import logo from "./logo.svg";
import "./App.css";
import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Hero from "./pages/HomePage/Hero";

const App: React.FC = () => {
  return (
    <div>
      <Hero />
    </div>
    // <Router>
    //   <div className="App">
    //     <Routes>
    //       <Route path="/" element={<HomePage />} />
    //       <Route path="/" element={<Hero />} />
    //     </Routes>
    //   </div>
    // </Router>

    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
  );
};

export default App;
